import { h, ComponentChildren } from "preact";

import classname from "../../../foundation/utils/classname";
import IconTick from "../../Icons/IconTick";

import styles from "./DialogListItem.module.css";

interface Props {
    children: ComponentChildren;
    newFeature?: boolean;
}

export default function DialogListItem({ children, newFeature }: Props) {
    return (
        <li class={classname(styles.listItem, { [styles.newFeature]: newFeature })}>
            <IconTick color="var(--gandalf)"/>
            {children}
        </li>
    );
}
